var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form",
        {
          ref: "form",
          attrs: {
            form: _vm.form,
            "label-col": { span: 12 },
            "wrapper-col": { span: 12 },
          },
        },
        [
          _c("div", { staticClass: "form_title" }, [_vm._v("基本信息")]),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "姓名" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["userName", _vm.rules.userName],
                            expression: "['userName', rules.userName]",
                          },
                        ],
                        attrs: { maxLength: 30 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "别名" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["nickName"],
                            expression: "['nickName']",
                          },
                        ],
                        attrs: { maxLength: 30 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "账号" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["userNo"],
                            expression: "['userNo']",
                          },
                        ],
                        attrs: { disabled: "" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "性别" } },
                    [
                      _c(
                        "a-radio-group",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["gender"],
                              expression: "['gender']",
                            },
                          ],
                        },
                        [
                          _c("a-radio", { attrs: { value: 1 } }, [
                            _vm._v("男"),
                          ]),
                          _c("a-radio", { attrs: { value: 2 } }, [
                            _vm._v("女"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "手机" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["mobile", _vm.rules.mobile],
                            expression: "['mobile', rules.mobile]",
                          },
                        ],
                        attrs: { maxLength: 30 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "座机" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["telephone"],
                            expression: "['telephone']",
                          },
                        ],
                        attrs: { maxLength: 30 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "邮箱" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["email"],
                            expression: "['email']",
                          },
                        ],
                        attrs: { maxLength: 64 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "部门" } },
                    [
                      _c("a-tree-select", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["deptId", _vm.rules.deptId],
                            expression: "['deptId',rules.deptId]",
                          },
                        ],
                        attrs: {
                          "allow-clear": "",
                          "dropdown-style": {
                            maxHeight: "300px",
                            overflow: "auto",
                          },
                          treeData: _vm.deptList,
                          "show-search": "",
                          treeDefaultExpandAll: false,
                          treeDefaultExpandedKeys: _vm.defaultExpandedKeys,
                          filterTreeNode: _vm.filterTreeNodeOption,
                          replaceFields: {
                            children: "children",
                            title: "deptName",
                            key: "deptId",
                            value: "deptId",
                          },
                        },
                        on: {
                          "update:treeDefaultExpandedKeys": function ($event) {
                            _vm.defaultExpandedKeys = $event
                          },
                          "update:tree-default-expanded-keys": function (
                            $event
                          ) {
                            _vm.defaultExpandedKeys = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "状态" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["statusName"],
                            expression: "['statusName']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "职务" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["position"],
                            expression: "['position']",
                          },
                        ],
                        attrs: { maxLength: 30 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "地址",
                        "label-col": { span: 4 },
                        "wrapper-col": { span: 20 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["address"],
                            expression: "['address']",
                          },
                        ],
                        attrs: { maxLength: 128 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "头像",
                        "label-col": { span: 4 },
                        "wrapper-col": { span: 20 },
                      },
                    },
                    [
                      _c("uploader", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["headImg"],
                            expression: "['headImg']",
                          },
                        ],
                        attrs: {
                          num: 1,
                          accept: "image/*",
                          url: _vm.api.temp.WX_UPLOAD_PATH + "?uploadType=2",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "form_title" }, [_vm._v("对外信息")]),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "职务" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["externalPosition"],
                            expression: "['externalPosition']",
                          },
                        ],
                        attrs: { maxLength: 30 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-tabs",
        [
          _c(
            "a-tab-pane",
            { key: "1", attrs: { tab: "角色", forceRender: true } },
            [
              _c("roleTable", {
                ref: "roleTable",
                attrs: { rowId: _vm.rowId },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-space",
        { staticClass: "a-form-btn-box" },
        [
          _c(
            "a-button",
            {
              on: {
                click: function ($event) {
                  return _vm.endEdit("cancelled")
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm._save(false)
                },
              },
            },
            [_vm._v("保存")]
          ),
          !_vm.keyId
            ? _c(
                "a-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveAndInvite },
                },
                [_vm._v("保存并发送邀请")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }